module.exports = __webpack_public_path__ + "static/images/social-facebook-square.913375cd42b1bc2b407a10958159dd88.svg";